import React from 'react';
import { IconPrev, IconNext, IconPlay, IconPause } from '../icons';

export default function TransportRow({
  variant = 'desktop', // 'desktop' | 'mobile'
  cx,
  t,
  playlist,
  playing,
  loading,
  togglePlay,
  handlePrevious,
  handleNext,
  handleButtonClickWithHint,
  iconClass,
  iconButtonBase,
  iconButtonIdle,
  iconButtonDisabled
}) {
  const isMobile = variant === 'mobile';

  return (
    <div
      className={isMobile ? 'flex items-center gap-2.5 flex-shrink-0' : 'flex items-center gap-2.5'}
      data-no-toggle
    >
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleButtonClickWithHint(e, () => handlePrevious({ immediate: true }), t('player.previous'));
        }}
        disabled={!playlist || playlist.length === 0}
        className={cx(iconButtonBase, iconButtonIdle, iconButtonDisabled)}
        title={t('player.previous')}
        data-no-toggle
      >
        <IconPrev className={iconClass} />
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleButtonClickWithHint(e, () => togglePlay(), playing ? t('player.pause') : t('player.play'));
        }}
        disabled={loading}
        className={cx(
          'h-10 w-10 inline-flex items-center justify-center rounded-md transition-all duration-150',
          'bg-gradient-to-b from-emerald-400 via-emerald-600 to-emerald-800 shadow-[0_10px_20px_rgba(16,185,129,0.32)] ring-1 ring-white/10',
          'hover:from-emerald-400 hover:via-emerald-600 hover:to-emerald-700',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300/80 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900',
          'active:scale-[0.98]',
          'disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100'
        )}
        title={playing ? t('player.pause') : t('player.play')}
        data-no-toggle
      >
        {loading ? (
          <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
        ) : playing ? (
          <IconPause className="w-6 h-6 drop-shadow-sm" />
        ) : (
          <IconPlay className="w-6 h-6 drop-shadow-sm" />
        )}
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleButtonClickWithHint(e, () => handleNext({ immediate: true }), t('player.next'));
        }}
        disabled={!playlist || playlist.length === 0}
        className={cx(iconButtonBase, iconButtonIdle, iconButtonDisabled)}
        title={t('player.next')}
        data-no-toggle
      >
        <IconNext className={iconClass} />
      </button>
    </div>
  );
}

